<app-modal title="Select an Account" [showCancel]="false" okText="Close">
	<div class="row vertical-center">
		<div class="col-xs-8" *ngIf="!loading">
			<mat-form-field appearance="outline" class="width-input">
				<mat-label [ngClass]="{'input-hide': accountSearch !== 'Description'}">Search</mat-label>
				<input matInput [(ngModel)]="searchInput" placeholder="Search" [ngClass]="{'input-hide': accountSearch !== 'Description'}"
					(input)="searchAccount()">
				<mat-icon matSuffix [ngClass]="{'input-hide': accountSearch !== 'Description'}">search</mat-icon>
				<input matInput [(ngModel)]="searchAccountInput" [ngClass]="{'input-hide': accountSearch === 'Description'}"
					(input)="filterAccounts(searchAccountInput)" [mask]="accountMask" [dropSpecialCharacters]="false" [patterns]="customPatterns"
					[showMaskTyped]="true">
			</mat-form-field>
		</div>
		<div class="col-xs-4">
			<label>Search By</label>
			<mat-radio-group class="mat-radio-group column-position" aria-label="Select an option" [(ngModel)]="accountSearch"
				(change)="applyFilter()">
				<mat-radio-button [checked]="true" value="AccountNumber">Account Code</mat-radio-button>
				<mat-radio-button value="Description">Description</mat-radio-button>
			</mat-radio-group>
		</div>
	</div>
	<div class="mat-elevation-z8">
		<table class="w-100" mat-table [dataSource]="dataSource" matSort aria-label="List">
			<ng-container matColumnDef="AccountNumber">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> Account # </th>
				<td mat-cell *matCellDef="let row"> {{row.AccountNumber}} </td>
			</ng-container>
			<ng-container matColumnDef="Description">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> Description </th>
				<td mat-cell *matCellDef="let row"> {{row.Description}} </td>
			</ng-container>
			<tr mat-header-row *matHeaderRowDef="displayedColumns" style="cursor: pointer;"></tr>
			<tr mat-row (click)="selectedAccount(row)" [class.demo-row-is-clicked]="clickedRows.has(row)"
				*matRowDef="let row; columns: displayedColumns;"></tr>
			<tr class="mat-row" *matNoDataRow>
				<td class="mat-cell" colspan="4">No Accounts Found</td>
			</tr>
		</table>
		<mat-paginator [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
	</div>
</app-modal>
